import { cva } from 'class-variance-authority'

export const variants = {
  position: {
    contained: 'absolute w-full h-full',
    screen: 'fixed w-screen h-screen z-40',
  },
  scrim: {
    none: '',
    sm: 'bg-neutral-light-3/80',
    md: 'bg-neutral-light-5/80',
    lg: 'bg-neutral-light-7/80',
  },
  centered: {
    true: 'flex items-center justify-center',
    false: '',
  },
} as const

export const overlayCva = cva('inset-0', {
  variants,
  defaultVariants: {
    position: 'contained',
    scrim: 'none',
    centered: false,
  },
})
